import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import React, { FC } from 'react';

import tableStore from '../../../../store/TableStore';
import { CloseTableButtonProps } from './CloseTableButton.types';

export const CloseTableButton: FC<CloseTableButtonProps> = ({
  table,
  inSidebar,
}) => {
  const onRemoveViewingTable = (): void => {
    if (
      tableStore.selectedFilterOptions.autoOpenTables &&
      tableStore.isTableSatisfyFilter(table)
    ) {
      confirmDialog({
        message: (
          <>
            <b>Auto-open tables mode</b> is enabled! Disable it to be able to
            <br />
            close tables
          </>
        ),
        header: 'Warning',
        icon: 'pi pi-exclamation-triangle',
        footer: <></>,
      });
    } else {
      tableStore.removeViewingTable(table.id);
    }
  };

  return (
    <Button
      icon="pi pi-times"
      className={inSidebar ? 'p-0 w-auto h-auto' : ''}
      rounded
      text
      severity="danger"
      aria-label="Close"
      tooltip="Close"
      onClick={onRemoveViewingTable}
    />
  );
};
